document.addEventListener('DOMContentLoaded', () => {
  console.log('✅ Script loaded');

  const productJsonEl = document.querySelector('#ProductJson');
  if (!productJsonEl) return;

  const productData = JSON.parse(productJsonEl.textContent);
  console.log('🧩 productData loaded', productData);

  // Find index of "Color" option
  let mainOptionName = 'Color';
  let optionIndex = productData.options.findIndex(
    opt => opt.toLowerCase() === 'color'
  );

  // All color inputs
  let optionInputsSelector = 'input[name^="options[Color]"]';
  let optionInputs = document.querySelectorAll(optionInputsSelector);
  console.log(`🎨 Found "${mainOptionName}" inputs:`, optionInputs.length);

  // ✅ Fallback: If only one color or none found, switch to "Opening"
  if (optionInputs.length <= 1 || optionIndex === -1) {
    const openingIndex = productData.options.findIndex(
      opt => opt.toLowerCase() === 'opening'
    );

    if (openingIndex !== -1) {
      mainOptionName = 'Opening';
      optionIndex = openingIndex;
      optionInputsSelector = `input[name^="options[${mainOptionName}]"]`;
      optionInputs = document.querySelectorAll(optionInputsSelector);
      console.log(`🪟 Using "${mainOptionName}" instead, found:`, optionInputs.length);
    } else {
      console.log('🟢 Only one option type found — showing all images.');
      const slides = document.querySelectorAll('.product__slide');
      const thumbs = document.querySelectorAll('.product__thumb');
      slides.forEach(el => (el.style.display = ''));
      thumbs.forEach(el => (el.style.display = ''));
      return;
    }
  }

  // Build option → image position mapping
  const optionImageRanges = {};
  productData.variants.forEach(variant => {
    if (variant.featured_media) {
      const value = variant[`option${optionIndex + 1}`];
      optionImageRanges[value] = variant.featured_media.position;
    }
  });

  // Build start/end ranges for each option value
  const sortedValues = Object.keys(optionImageRanges).sort(
    (a, b) => optionImageRanges[a] - optionImageRanges[b]
  );

  const optionImageGroups = {};
  sortedValues.forEach((value, i) => {
    const start = optionImageRanges[value];
    const end =
      i < sortedValues.length - 1
        ? optionImageRanges[sortedValues[i + 1]] - 1
        : productData.media.length;
    optionImageGroups[value] = { start, end };
  });

  console.log(`📊 ${mainOptionName} image groups`, optionImageGroups);

  // Function to show/hide both slides and thumbs
  function updateImages(selectedValue) {
    const group = optionImageGroups[selectedValue];
    if (!group) {
      console.warn(`⚠️ No image group found for ${mainOptionName}:`, selectedValue);
      return;
    }

    console.log(`🎯 Updating images for "${selectedValue}"`, group);

    const slides = document.querySelectorAll('.product__slide');
    const thumbs = document.querySelectorAll('.product__thumb');

    slides.forEach((el, index) => {
      const pos = index + 1;
      el.style.display = pos >= group.start && pos <= group.end ? '' : 'none';
    });

    thumbs.forEach((el, index) => {
      const pos = index + 1;
      el.style.display = pos >= group.start && pos <= group.end ? '' : 'none';
    });
  }

  // Run on option change
  optionInputs.forEach(input => {
    input.addEventListener('change', () => updateImages(input.value));
  });

  // Run once gallery is ready
  const productComponent = document.querySelector('product-component');
  if (productComponent) {
    const observer = new MutationObserver(() => {
      const slides = document.querySelectorAll('.product__slide');
      if (slides.length) {
        observer.disconnect();
        const selected = document.querySelector(`${optionInputsSelector}:checked`);
        if (selected) updateImages(selected.value);
      }
    });
    observer.observe(productComponent, { childList: true, subtree: true });
  }
});
